import { TooltipProps } from '../../../CommonComponents/OPL/Tooltip/Tooltip';

export enum ModelGroupType {
  Orion = 'orion',
  Custom = 'custom',
}

export const TEMP_PREFIX = 'temp__';

export const tooltipProps: Partial<TooltipProps> = {
  delay: [1000, 0],
  trigger: 'mouseenter',
  placement: 'top',
};
